(function () {
  function activate(section, tabId) {
    var tabs = section.querySelectorAll('[data-mt-wp-tab]');
    var panels = section.querySelectorAll('[data-mt-wp-panel]');

    for (var i = 0; i < tabs.length; i++) {
      var isActive = tabs[i].getAttribute('data-mt-wp-tab') === tabId;
      tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive && typeof tabs[i].scrollIntoView === 'function') {
        tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].getAttribute('data-mt-wp-panel') !== tabId;
    }
  }

  function init(section) {
    if (!section || section.dataset.mtWpInit === 'true') return;
    section.dataset.mtWpInit = 'true';

    var tabs = section.querySelectorAll('[data-mt-wp-tab]');
    if (!tabs.length) return;

    section.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-mt-wp-tab]');
      if (!tab || !section.contains(tab)) return;
      activate(section, tab.getAttribute('data-mt-wp-tab'));
    });

    section.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var tab = event.target.closest('[data-mt-wp-tab]');
      if (!tab || !section.contains(tab)) return;

      var list = Array.prototype.slice.call(section.querySelectorAll('[data-mt-wp-tab]'));
      var next = list[list.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1)];
      if (!next) return;

      event.preventDefault();
      activate(section, next.getAttribute('data-mt-wp-tab'));
      next.focus();
    });
  }

  function initAll(root) {
    var sections = (root || document).querySelectorAll('.mt-womo-popular');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
